import * as React from 'react';
import { useCopilotMessageFooter_unstable } from './useCopilotMessageFooter';
import { renderCopilotMessageFooter_unstable } from './renderCopilotMessageFooter';
import { useCopilotMessageFooterStyles_unstable } from './useCopilotMessageFooterStyles';
// CopilotMessageFooter component
export const CopilotMessageFooter = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useCopilotMessageFooter_unstable(props, ref);
  useCopilotMessageFooterStyles_unstable(state);
  return renderCopilotMessageFooter_unstable(state);
});
CopilotMessageFooter.displayName = 'CopilotMessageFooter';
//# sourceMappingURL=CopilotMessageFooter.js.map